export const locale = {
    lang: 'es',
    data: {
      'RESULTADOS': {
        'TITULO': 'RESULTADOS',
        'DESCRIP': 'Selecciona una opción',
        'CARGANDO': 'Cargando los resultados de la encuesta de la empresa',
        'COMINGSOON': 'Resultados de la encuesta COVID próximamente...',
        'VALIDANDO': {
          'BOTON': 'En proceso de validación',
          'MENSAJE': 'Los resultados de este producto se encuentran en proceso de validación, próximamente serán puestos a su disposición',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Año',
          'COL2':'Acceso',
          'BOT':'Acceso',
        },

        'SECCIONES': {
          'TITULO_VER':'Versión ',
          'NOSECCIONES': 'No hay secciones disponibles',
          'CERTIFICAR': {
            'TITULO': 'CERTIFICAR',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR': {
            'TITULO': 'MEDIR',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR_INNO': {
            'TITULO': 'Innmotion survey',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'CertiAdicio': {
            'TITULO': 'CERTIFICACIONES ADICIONALES',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'TrabDign': {
            'TITULO': 'TRABAJO DIGNO',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'PrimEmp': {
            'TITULO': 'PRIMER EMPLEO',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'GOFLOW': {
            'TITULO': 'Resultados GoFlow',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
        },
        'TABPRIN':{
          'TABPRO':'Proceso de certificación',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Procesos de medir',
          'TABPULSE':'Procesos de pulse check',
          'TABICI': 'Resultados de ICI',
          'TABINNO': 'Resultados de Innmotion survey',
          'TABAMCO': 'Procesos de AMCO',
          'TABTRABDIG': 'Procesos de trabajo digno',
          'TABPRIEMP': 'Procesos de primer empleo',
        },
        'TABPRIN5':{
          'TABPRO':'Proceso de versión 3.1 Globales',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Proceso de versión 3.2 Lider',
          'TABPULSE':'Proceso de versión 3.3 Covid',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL resultados heredados',
         'BOTON': 'Iniciar',
         'SIN_4ALL_HEREDADAS':'Usted no cuenta con resultados heredados de FORALL',
         'TITULOCERTIFICAR':'Certificar',
         'APLICACIONANIO':'Año de aplicación: 2019',
        },
        '4ALL':{
             'CARGANDO':'Cargando resultados FORALL',
             'TITULO4ALL':'RESULTADOS DE PRÁCTICAS',
             'TABPRACTICAS':{
              'TITULOTAB':'Practicas 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC':'Resultado global de prácticas FORALL',
              'TEXTO1':'Porcentaje de ',
              'TEXTO2':'conocimiento de las prácticas FORALL',
              'TEXTO3':'en tu organización',
              'TEXTO4':'Nivel de',
              'TEXTO5':'satisfacción de los colaboradores que conocen',
              'TEXTO6':'las prácticas FORALL',
            },
            'TITULOPRAC4All':{
              'TITULOTAB':'Demograficos',
              'SUBTITULO4ALL':'Resultados por prácticas FORALL',
              'TITULOCONO':'CONOCIMIENTO',
              'TEXTO1':'Porcentaje de conocimiento de las prácticas FORALL en tu organización',
              'TITULOSATIS':'SATISFACCIÓN',
              'TEXTO2':'Nivel de satisfacción de los colaboradores que conocen la práctica FORALL',
            },
          },

      'DEMOGRAFICOS':{
        'Cargo homologado ': 'Cargo Homologado ',
        'Años de Trabajo': 'Antiguedad',
        'Condición de trabajo': 'Condición de trabajo',
        'Tipo de trabajo': 'Esquema Compensacion',
        'Género': 'Genero',
        'Educación': 'Grado Academico',
        'PORCONOTXT1': 'Porcentaje de',
        'PORCONOTXT2': 'conocimiento de las prácticas FORALL',
        'PORCONOTXT3': 'por corte demográfico',
        'PORSATITXT1': 'Nivel de',
        'PORSATITXT2': 'satisfacción de los colaboradores que conocen las prácticas FORALL',
        'PORSATITXT3': 'por corte demográfico',
      },
      'MODL_N_RESU':'Actualmente no hay resultados',
      'MODL_N_RESU_4ALL':'No es posible mostrar los resultados solicitados',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":'No se encontró platformKey de resultados',
           "ETQ_PROD":"Producto: ",
           "ETQ_BROK":"Broker: ",
           "ETQ_COUN":"País: ",
           "ETQ_LANG":"Idioma: ",
           "ETQ_CERTY":"Certificado: ",
           "true":"Activado",
           "false":"Desactivado",
           "COUNTR_NO_SELEC":"*No seleccionado*",
         }
       },
       'RESULTADOS_5':{
        'TITULO': 'RESULTADOS 5.0',
        'SECCIONES': {
          'NOSECCIONES': 'No hay secciones disponibles',
          '31': {
            'TITULO': 'Versión 3.1 Globales',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          '32': {
            'TITULO': 'Versión 3.2 Líderes',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          '33': {
            'TITULO': 'Versión 3.3 Covid',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          }
        },
      },
      'CONFING_RESUL':{
      'TITULO_MODAL':'Configuración de resultados BenchMarks',
      'TAB_DEMO_EXCEL':'Demograficos excel',
      'SUB_TIT_TAB_DEMO_EXCEL':'Seleccione los demograficos:',
      'TAB_DEMO_ENCU':'Demograficos encuesta',
      'SUB_TIT_TAB_DEMO_ENCU':'Seleccione los demograficos:',
      'TAB_BENCHMA':'BenchMarks',
      'SUB_TIT_TAB_BENCHMA':'',
      'TITULO_MAT_EXPAN_TAMANO':'Top',
      'TITULO_MAT_EXPAN_SECTOR':'Sectorial',
      'TITULO_MAT_EXPAN_REGIONAL':'Rangos',
      'OKSELECT':'Seleccionado',
      'NOTSELECT':'No seleccionado',
      'TAB_NIV_GEOG':'Niveles geograficos',
      'SUB_TIT_TAB_NIV_GEOG':'Seleccione los niveles geograficos:',
      'TAB_NIV_ESTRUC':'Niveles estructurales',
      'SUB_TIT_TAB_NIV_ESTRUC':'Seleccione los niveles estructurales:',
      'BTN_ACEPTAR':'Aceptar',
      'MODAL_CARGA_DEMO_EXC':'Cargando demograficos',
      'MODAL_CARGA_DEMO_ENC':'Cargando demograficos encuesta',
      'MODAL_CARGA_BENCH':'Cargando BenchMarks',
      'MODAL_CARGA_NIV_GEO':'Cargando niveles geograficos',
      'MODAL_CARGA_NIV_ESTR':'Cargando niveles estructurales',
      'TAB_BENCH_MARK':'Punto de referencia',
      'MODAL_CARGA_BENCH_MARK':'Cargando punto de referencia',
      'SUB_TIT_TAB_BENCH_MARK':'Seleccione punto de referencia:',
      'SUCCES_GUAR_SELEC':'Se guardaron las modificaciones correctamente',
      'CONFI_GUAR_SELE':'¿Está seguro de guardar los cambios realizados?',
      'RES_SI':'Si',
      'RES_NO':'No',
      'MAT_TOOL_BTN_CONFI_RESULT':'Configuración de resultados',
      'MODAL_GUA_INFOR':'Guardando Información',
      'SUB_TIT_TAB_HIERARCHI':'Selección de HierarchicalPaths:',
      'MODAL_CARGA_HIERARCHI':'Cargando hierarchicalPaths',
      'SIN__HIERARCHI_MOSTRAR':'Actualmente no hay resultados en hierarchicalPaths',
      'EXTERNAL_PORTAL':'Copie la url de 4all externo',
      'INTRU_TEX_BENCHMARK':'*Mueve los BenchMarks',
      'BENCHMARCK_SELEC':'BenchMarks seleccionados en orden de presentación:',
      'BTN_SAV_BENCH':'Guardar BenchMarks',
      'TEX_SEARC_BENCH_TOP':'Ingresar BenchMarks top a buscar',
      'TEX_SEARC_BENCH_SECT':'Ingresar BenchMarks sectorial a buscar',
      'TEX_SEARC_BENCH_RANG':'Ingresar BenchMarks rango a buscar',
      'TEX_SEARC_BENCH':'Ingresar BenchMark a buscar',
      'INFO_MAS_BENCH_ESPA':'BenchMarks agrupados',
      'BTN_ADD_BENCH_SUGE':'Agregar sugeridos',
      'MOD_WARN_MAX_PERMIT':'No es posible agregarlo, ya que excede en número de espacios permitidos',
      'MOD_WARN_UN_CATE':'Actualmente ya existe un Benchmark de la catergoria seleccionado',
      'MOD_WARN_NO_APLIC':'No es posible agregarlo, ya que está habilitado la opción de no seleccionar los BenchMarks',
      'INSTRU_DRAP&DROP_1':'Arrastre y suelte el BenchMark aquí',
      'LABE_CIRC_PROGRE':'BenchMarks',
      'LABE_INSTRU_SELECT_BENCH':'¿Deseas seleccionar los BenchMarks?',
    },
      'CONFING_RESUL_GOFLOW':{
      'TITULO_MODAL':'Información de Resultados GoFlow',
        },
    'CONFING_RESUL_EMP':{
    'TITULO_MODAL':'Raw Data Emprising',
    'INT_TEX':'Instruccion: Por favor, sube el archivo Raw Data a importar.',
    'TOOLT_CHA_INF':'Seleccioné el archivo',
    'UPLO_INF':'Importando información row data',
    'SUCC_UPLO_INF':'Se importo correctamente',
    }
    }
};
